import Image from "next/image";

const InfoRow = ({ icon, label, children }) => {
  return (
    <div className="info-row d-flex mb-4">
      <div className="info-row-icon me-2">
        <Image
          src={`/img/icons/${icon}.png`}
          width={24}
          height={24}
          unoptimized={true}
        />
      </div>
      <div className="content-section w-100">
        <h6 className="mb-2 mt-1">{label}</h6>
        <div>{children}</div>
      </div>
    </div>
  );
};

export default InfoRow;
